import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// Types
import { AuthContextType } from '../../../../../../hooks/useAuth';

// GraphQL
import { selectAllMultimediaByOrderId } from '../../../../../../gql/selectors/multimedia';

const loadMultimediaGrid = async (
  idOrder: string,
  userData: AuthContextType | null
) => {
  try {
    // Use new selector that aggregates images from parent order AND child orders (actions/accidents)
    const { images, hasChildImages } =
      await selectAllMultimediaByOrderId(idOrder);

    return {
      images,
      hasChildImages,
      operator: `${userData?.user?.user?.name} ${
        userData?.user?.user?.surName.split(' ')[0]
      }`,
    };
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Multimedia Grid loading error:', err);
    return false;
  }
};
export const LoaderGeneralViewMultimediaGrid: (
  userData: AuthContextType | null
) => LoaderFunction =
  (userData) =>
  async ({ params }) => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
    if (!params.id) return null;
    // if (Object.keys(client.cache.extract()).length === 0) return null;

    const loaderToResolve = loadMultimediaGrid(params.id, userData);

    return loaderToResolve;
  };

  return { data: load() };
};
